import { render } from "./AposTiptapDivider.vue?vue&type=template&id=23f0af64&scoped=true"
import script from "./AposTiptapDivider.vue?vue&type=script&lang=js"
export * from "./AposTiptapDivider.vue?vue&type=script&lang=js"

import "./AposTiptapDivider.vue?vue&type=style&index=0&id=23f0af64&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23f0af64"],['__file',"rich-text-widget/ui/apos/components/AposTiptapDivider.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "23f0af64"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('23f0af64', __exports__)) {
    api.reload('23f0af64', __exports__)
  }
  
  module.hot.accept("./AposTiptapDivider.vue?vue&type=template&id=23f0af64&scoped=true", () => {
    api.rerender('23f0af64', render)
  })

}


export default __exports__